var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/home"}},[_c('svg-icon',{attrs:{"icon-class":"matr1x_fire_logo","class-name":"logo-svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }